import React, {useCallback, useContext} from 'react';
import {Constants} from '../../view-constants.js';
import {articleOverviewStaticContext} from '../../ArticleOverviewStatic.jsx';
import {Button, Icon, Typography} from '@bonprix/design-system';
import {loadOnAccordeon, selectFilterLoadingbarStatus, selectLoadingbarStatus} from '../../LoaderSlice.jsx';
import {closeFilter} from '../../FilterSlice.jsx';
import {useDispatch, useSelector} from 'react-redux';
import {yieldToMain} from '../../ArticleOverviewHelper.js';
import {setFilterAjaxCall} from '../../AjaxCallSlice.jsx';
import {useTrinity} from '../../hooks/use-trinity.js';
import {useChangeFilters} from '@article-overview/components/hooks/use-change-filters.js';
import {useAppState} from '@core/scripts/modules/shoppingApp/appState.ts';

function FilterLayerMobile({hits, filterSubmit, btnRef, children}) {
    const {texts, browser, currentSearchParams} = useContext(articleOverviewStaticContext);
    const contentLoading = useSelector(selectLoadingbarStatus).status;
    const filterLoading = useSelector(selectFilterLoadingbarStatus).status;

    const dispatch = useDispatch();
    const {resetFilters} = useChangeFilters();

    const {sendClickBasic} = useTrinity();

    const appState = useAppState();
    const appSafeAreaBottom = appState?.metadata?.safeAreaInsets?.bottom ?? 0;

    const isIphone =
        browser === Constants.SAFARI_BROWSER && navigator.userAgent.indexOf(Constants.USER_AGENT_IPHONE) !== -1;
    const groupsStyle = isIphone ? {height: window.innerHeight} : {};

    const submitButtonClick = useCallback(() => {
        yieldToMain(() => {
            dispatch(loadOnAccordeon());
            filterSubmit();
        });
    }, [filterSubmit]);

    const resetFilterAjaxCallAndClose = () => {
        dispatch(setFilterAjaxCall(['', false]));
        dispatch(closeFilter());
    };
    const resetFilterClick = () => {
        const hasFilters = Array.from(currentSearchParams.current.keys()).some((key) =>
            key.startsWith(Constants.FILTER_PARAM_PREFIX),
        );
        const hasOrdering = currentSearchParams.current.has(Constants.SEARCH_PARAMS_ORDERING);

        // If no filters or ordering to reset, just close the sidesheet
        if (!hasFilters && !hasOrdering) {
            resetFilterAjaxCallAndClose();
            return;
        }

        yieldToMain(() => dispatch(loadOnAccordeon()));
        resetFilters(true);
        sendClickBasic('reset_filter', Constants.FILTER_VIEW_EVENT_VERSION);
    };

    // TODO: refactor - remove -small
    return (
        <div className="filter__mobile-layer" style={groupsStyle}>
            {renderHeadline()}
            <div className="filter__headline-line"></div>
            {children}
            {renderSubmitButton()}
        </div>
    );

    function renderHeadline() {
        const handleCloseFilter = () => {
            resetFilterAjaxCallAndClose();
            // remove #filterLayer from url
            history.replaceState(null, null, window.location.pathname + window.location.search);
            sendClickBasic('close_filter_sorting', Constants.FILTER_VIEW_EVENT_VERSION);
        };
        return (
            <div className="filter__headline-wrapper">
                <Typography component={'div'} variant={'bonprix-h5'}>
                    {texts.filter_title}
                </Typography>
                <div className="filter__headline-icon" onClick={handleCloseFilter}>
                    <Icon variant="closer" />
                </div>
            </div>
        );
    }

    function renderSubmitButton() {
        return (
            <div
                className={`filter-layer__button-area ${appSafeAreaBottom > 0 ? `px-6 bg-white` : ''}`}
                test-ref__filter-submit-button=""
                ref={btnRef}
                style={{
                    marginBottom: appSafeAreaBottom,
                }}
            >
                <Button
                    onClick={submitButtonClick}
                    variant="primary"
                    size="large"
                    loading={contentLoading}
                    disabled={filterLoading || hits === 0}
                    id="filter-submit-button"
                >
                    {hits === 1 ? `${hits} ${texts.filter_result}` : `${hits} ${texts.filter_results}`}
                </Button>
                <Button onClick={resetFilterClick} variant="secondary" size="large" disabled={filterLoading}>
                    {texts.filter_reset_sidesheet}
                </Button>
            </div>
        );
    }
}

export default React.memo(FilterLayerMobile);
